import { useEffect, useState, useRef } from "react";
import BottomIcon from '@src/component/bottomIcon'
import "./index.scss";
import { Form, Input, Toast } from 'antd-mobile'
import CustomScroll from '@src/component/customScroll'
import UploadImg from '@src/component/uploadImg'
import ProgressBar from "@src/component/ProgressBar";
import { imageSyncScan, submitBank, getfindBank, getApplyInfoByIdf, recognition } from "@service/applyFormSubService"
import { isEmpty, verifyPhone, verifyBankCard, regular, getQueryParams } from "@src/util";
import { goto } from "@src/route";
import MiModal from "@src/component/miModal";
import store from '@src/util/store'

export default function Index() {
    const [form] = Form.useForm()
    const [identityFrony, setIdentityFrony] = useState<any>(null)
    const [inputShow, setInputShow] = useState<boolean>(false)
    const [verification, setVerification] = useState<boolean>(true)
    const loanid = getQueryParams()['loanId'] || store.get('loanid') || ''
    const [visible, setVisible] = useState<boolean>(false);
    const no = getQueryParams()['no']
    const refFrony = useRef(null);
    // 设置title
    useEffect(() => {
        document.title = "上传银行卡";
    }, [])

    // 判断是否显示身份输入信息
    useEffect(() => {
        if (identityFrony) {
            setInputShow(true)
        } else {
            setInputShow(false)
        }
    }, [identityFrony])

    // 回填数据
    useEffect(() => {
        // 获取提交数据
        if (loanid) {
            getfindBank(loanid).then(res => {
                if (res) {
                    setData(res)
                } else {
                    getHistory()
                }
            }).catch(err => {
                err?.errmsg && Toast.show(err?.errmsg)
                getHistory()
            })
        } else {
            getHistory()
        }
    }, [])
    // 获取历史数据
    const getHistory = () => {
        // 获取历史数据
        getApplyInfoByIdf().then(ret => {
            if (ret) {
                ret?.loanBank && setData(ret.loanBank)
                store.set('history', ret)
            }
        }).catch((err: any) => {
            err?.errmsg && Toast.show(err?.errmsg)
        })
    }
    // 回填数据
    const setData = (res: any) => {
        form.setFieldsValue({
            accountNo: res.accountNo,
            bankName: res.bankName,
            mobile: res.mobile
        })
        if (res.bank) {
            setIdentityFrony({
                id: res.bank,
                accountNo: res.accountNo
            });
            refFrony.current?.setFileList([{ url: res.bankUrl }]);
        }
    }
    // 获取所属银行
    const recognitionCode = (accounNo: string) => {
        recognition(accounNo).then(res => {
            setVerification(true)
            form.setFieldsValue({
                bankName: res
            });
        }).catch(err => {
            setVerification(false)
            form.setFieldsValue({
                bankName: ''
            });
            err?.errmsg && Toast.show(err?.errmsg)
        })
    }
    // 银行卡正面
    const onChanegeFrony = (file: any) => {
        if (file[0] && file[0].id) {
            Toast.show({
                icon: 'loading',
                content: '银行卡识别中…',
                duration: 0,
                maskClickable: false
            })
            imageSyncScan(file[0].id, 3).then(res => {
                Toast.clear()
                if (!isEmpty(res.bankCardNum)) {
                    setIdentityFrony({
                        id: file[0].id,
                        accountNo: res.bankCardNum,
                    })
                    recognitionCode(res.bankCardNum)
                    form.setFieldsValue({
                        accountNo: res.bankCardNum,
                    })
                } else {
                    Toast.show('银行卡信息识别失败，请手动填写信息')
                    setIdentityFrony({
                        id: file[0].id,
                        accountNo: ''
                    });
                    form.setFieldsValue({
                        accountNo: '',
                        bankName: '',
                        mobile: '',
                    })
                    // (refFrony?.current as any)?.setFileList([])
                }
            }).catch(err => {
                Toast.show(`${(err?.errmsg as string) || '银行卡信息识别失败'} ，请手动填写信息`)
                setIdentityFrony({
                    id: file[0].id,
                    accountNo: ''
                });
                form.setFieldsValue({
                    accountNo: '',
                    bankName: '',
                    mobile: '',
                })
                // (refFrony?.current as any)?.setFileList([])
            })
        } else {
            setIdentityFrony(null)
        }
    }

    // 点击下一步
    const netxClick = () => {
        if (!identityFrony) {
            Toast.show('请上传您的银行卡正面')
            return
        }
        form.validateFields().then(() => {
            if (verification) {
                subMitData()
            } else {
                setVisible(true)
            }
        })
    }

    const subMitData = () => {
        form.validateFields().then(res => {
            res.bank = identityFrony.id
            res.loanid = loanid
            res.no = no
            Toast.show({
                icon: 'loading',
                content: '加载中…',
                duration: 0,
                maskClickable: false
            })
            submitBank(res).then(res => {
                store.set('loanid', res)
                Toast.clear()
                goto('/apply/w2')
            }).catch(err => {
                console.log(err)
                Toast.show(err?.errmsg || '数据保存失败！')
            })
        })
    }

    return (<div className="page bottomFit uploadsfz">
        <ProgressBar point={40} />
        <CustomScroll>
            <header>
                <div className="title dotted-line">上传银行卡号面照片</div>
                <div className="uploadId-box">
                    <UploadImg ref={refFrony} onChanege={onChanegeFrony}>
                        <div className="box-show">
                            <div className="upload-Icon">
                                <div className="upload-peoIcon">
                                    <i className="upload-addIcon"></i>
                                </div>
                            </div>
                        </div>
                    </UploadImg>
                    {!inputShow && <div className="box-text">上传银行卡号面照片</div>}
                </div>
            </header>
            {(!inputShow) && <section>
                <ul>
                    <li>
                        <div className="content-img">
                            <div className="content-IDright" />
                        </div>
                        <div className="content-text"><i className="rightIcon" />标准拍摄</div>
                    </li>
                    <li>
                        <div className="content-img">
                            <div className="content-IDdef" />
                        </div>
                        <div className="content-text"><i className="defIcon" />边框缺失</div>
                    </li>
                    <li>
                        <div className="content-img">
                            <div className="content-IDright dim" />
                        </div>
                        <div className="content-text"><i className="defIcon" />照片模糊</div>
                    </li>
                </ul>
            </section>}
            {inputShow && <div className="inputForm">
                <div className="title dotted-line">请确认您的银行卡信息</div>
                <div className="from-box">
                    <Form form={form} layout='horizontal'>
                        <Form.Item name='accountNo' label='还款银行卡号：' rules={[{ validator: verifyBankCard }]}>
                            <Input placeholder='请输入还款银行卡号' onChange={() => {
                                form.setFieldsValue({
                                    accountNo: form.getFieldValue('accountNo').replace(/\D/g, '').substring(0, 21)
                                })
                                if (regular('bankCard').test(form.getFieldValue('accountNo'))) {
                                    recognitionCode(form.getFieldValue('accountNo'))
                                }
                            }} />
                        </Form.Item>
                        <div className="tipssatt">
                            <Form.Item name="bankName" label='所属银行：' rules={[{ required: true, message: '请输入所属银行' }]}>
                                <Input placeholder='请输入所属银行' maxLength={25} />
                            </Form.Item>
                            <div className="tipsa">（如中国工商银行）</div>
                        </div>
                        <Form.Item name="mobile" label='银行预留手机号：' rules={[{ validator: verifyPhone }]}>
                            <Input placeholder='请输入银行预留手机号' type="number" onChange={() => {
                                form.setFieldsValue({
                                    mobile: form.getFieldValue('mobile').replace(/\D/g, '').substring(0, 11)
                                })
                            }} />
                        </Form.Item>
                    </Form>
                </div>
            </div>}
        </CustomScroll>
        <footer>
            <div className="button-them upload-next" onClick={netxClick}>下一步</div>
        </footer>
        <MiModal visible={visible} setVisible={setVisible} onSubmit={() => { subMitData() }} content={<div className="miModal-content">未查询到该卡号所属银行，卡号可能有误，确认提交？</div>} />
        <BottomIcon />
    </div>)
}
